/* eslint-disable no-console */
import { Button } from '@hologram-dimension/button';
import { PanelNotification } from '@hologram-dimension/panel-notification';
import { Component } from 'react';

class ErrorBoundary extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = { error: '' };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    const { showErrorWrapper = true } = this.props;
    if (showErrorWrapper) {
      console.error({ type: 'Uncaught error', error, errorInfo });
    }
  }

  render() {
    const { error } = this.state;
    const { children, showErrorWrapper = true } = this.props;

    if (error) {
      return (
        showErrorWrapper && (
          <PanelNotification
            className="ErrorBoundary"
            variant="error"
            label="We ran into an issue loading the current page"
            actions={
              <>
                <Button
                  variant="secondary"
                  onClick={() => window.location.reload()}
                  iconStart="ArrowWestLong"
                >
                  Go back
                </Button>
                <Button
                  variant="secondary"
                  iconStart="Sync"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Reload page
                </Button>
                <Button to="/">Go to Dashboard</Button>
              </>
            }
          >
            {`${error}`}
          </PanelNotification>
        )
      );
    }
    return children;
  }
}

export default ErrorBoundary;
